'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _schemas = require('../../data/schemas.js');

var _normalizr = require('normalizr');

var _actionTypes = require('./actionTypes');

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  datasourceData: {},
  selectedIndex: undefined,
  selectedDataId: undefined,
  createNew: false,
  showDataForId: undefined,
  removedId: undefined,
  removedDataId: undefined,
  createNewData: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes.SET_SELECTED_INDEX:
      return _ramda2.default.assoc('selectedIndex', payload, state);

    case actionTypes.SET_SELECTED_DATA_ID:
      return _ramda2.default.assoc('selectedDataId', payload, state);

    case actionTypes.START_CREATE_ITEM:
      return _ramda2.default.assoc('createNew', true, state);

    case actionTypes.END_CREATE_ITEM:
      return _ramda2.default.assoc('createNew', false, state);

    case actionTypes.SET_CONFIRM_REMOVE:
      return _ramda2.default.assoc('removedId', payload, state);

    case actionTypes.CLEAR_CONFIRM_REMOVE:
      return _ramda2.default.assoc('removedId', undefined, state);

    case actionTypes.SET_CONFIRM_REMOVE_DATA:
      return _ramda2.default.assoc('removedDataId', payload, state);

    case actionTypes.CLEAR_CONFIRM_REMOVE_DATA:
      return _ramda2.default.assoc('removedDataId', undefined, state);

    case actionTypes.SET_SHOW_DATA:
      return _ramda2.default.assoc('showDataForId', payload, state);

    case actionTypes.START_CREATE_DATA_ITEM:
      return _ramda2.default.assoc('createNewData', true, state);

    case actionTypes.END_CREATE_DATA_ITEM:
      return _ramda2.default.assoc('createNewData', false, state);

    case actionTypes.GET_DATASOURCE_DATA_SUCCESS:
      {
        var url = payload.req.url,
            body = payload.body;

        var datasourceId = _ramda2.default.compose(_ramda2.default.nth(-2), _ramda2.default.split('/'))(url);
        return _ramda2.default.assoc('datasourceData', (0, _defineProperty3.default)({}, datasourceId, (0, _normalizr.normalize)(body, _schemas.itemsListSchema)), state);
        //        return R.evolve({
        //          schemas: R.always(normalize(body, itemsListSchema)),
        //        }, state)
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Datasources/reducer.js
// module id = 1112
// module chunks = 5